import React from 'react';
import { ThemeProvider } from 'styled-components';
import { MotionConfig } from 'framer-motion';
import { lightThemeWithName, darkThemeWithName } from './styles/theme';
import { GlobalStyles } from './styles/GlobalStyles';
import { AppProvider, useAppContext } from './context/AppContext';

// Components
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Experience from './components/Experience';
import Skills from './components/Skills';
import Craft from './components/Craft';
import Projects from './components/Projects';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import AmbientBackground from './components/common/AmbientBackground';

const AppContent: React.FC = () => {
  const { effectiveTheme } = useAppContext();
  const currentTheme = effectiveTheme === 'light' ? lightThemeWithName : darkThemeWithName;

  return (
    <ThemeProvider theme={currentTheme}>
      <MotionConfig reducedMotion="user">
        <GlobalStyles />
        <AmbientBackground />
        <Header />
        <main>
          <Hero />
          <About />
          <Craft />
          <Experience />
          <Skills />
          <Projects />
          <Contact />
        </main>
        <Footer />
        <ScrollToTop />
      </MotionConfig>
    </ThemeProvider>
  );
};

const App: React.FC = () => {
  return (
    <AppProvider>
      <AppContent />
    </AppProvider>
  );
};

export default App;
